import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Title, Stack, Group, ActionIcon, Paper, Text } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { PageContainer } from '../components/PageContainer';

export function AboutPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageContainer>
      <Stack gap="md">
        <Group>
          <ActionIcon variant="subtle" onClick={() => navigate(-1)}>
            <IconArrowLeft size={20} />
          </ActionIcon>
          <Title order={2} style={{ fontSize: 'var(--font-size-lg)' }}>{t('about.title')}</Title>
        </Group>

        <Paper p="md" withBorder>
          <Stack gap="sm">
            <Group justify="space-between">
              <Text c="dimmed" style={{ fontSize: 'var(--font-size-sm)' }}>{t('about.version')}</Text>
              <Text fw={500} style={{ fontSize: 'var(--font-size-sm)' }}>1.0.0</Text>
            </Group>
            <Group justify="space-between">
              <Text c="dimmed" style={{ fontSize: 'var(--font-size-sm)' }}>{t('about.app_name') || 'Приложение'}</Text>
              <Text fw={500} style={{ fontSize: 'var(--font-size-sm)' }}>NRE CRM</Text>
            </Group>
          </Stack>
        </Paper>
      </Stack>
    </PageContainer>
  );
}

export default AboutPage;
